import * as React from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/Dashboard';
import Directions from '@material-ui/icons/Directions';
import LocationOn from '@material-ui/icons/LocationOn';
import PeopleIcon from '@material-ui/icons/People';
import MessageIcon from '@material-ui/icons/Message';
import DriveEta from '@material-ui/icons/Motorcycle';
import LocalOffer from '@material-ui/icons/CardTravel';
import BusinessIcon from '@material-ui/icons/Business';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Link } from 'react-router-dom'
import Divider from '@material-ui/core/Divider';
import { Collapse, List } from '@material-ui/core';
import { ExpandLess, ExpandMore, TouchApp, Store, AddLocation } from '@material-ui/icons';
import { ConfigData } from './config';

export const menu = (
    open: boolean,
    openRepartos: boolean,
    openEnterprise: boolean,
    openReportes: boolean,
    cambiar: () => void,
    cambiarEnterprise: () => void,
    cambiarRepartos: () => void,
    cambiarReportes: () => void,
    config: ConfigData) => {
    return <div>
        <List>
            {config && config.menu && config.menu.showDashboard !== false && (
                <Link to="/">
                    <ListItem button>
                        <ListItemIcon>
                            <InboxIcon />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItem>
                </Link>
            )}
            {config && config.menu && config.menu.showRepartos !== false && (
                <>
                    <ListItem button onClick={() => cambiarRepartos()}   >
                        <ListItemIcon>
                            <Directions />
                        </ListItemIcon>
                        <ListItemText primary="REPARTOS" />
                        {openRepartos ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openRepartos} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {config && config.menu && config.menu.showNuevoReparto !== false && (
                                <Link to="/races/add">
                                    <ListItem button>
                                        <ListItemIcon>
                                            <AddLocation />
                                        </ListItemIcon>
                                        <ListItemText primary="Nuevo Reparto" />
                                    </ListItem>
                                </Link>
                            )}
                            {/* <Link to="/planificacion">
                                <ListItem button>
                                    <ListItemIcon>
                                        <LocationOn />
                                    </ListItemIcon>
                                    <ListItemText primary="Planificación" />
                                </ListItem>
                            </Link> */}
                            {config && config.menu && config.menu.showPlanificacionMultidia !== false && (
                                <Link to="/planificacion-multiday">
                                    <ListItem button>
                                        <ListItemIcon>
                                            <LocationOn />
                                        </ListItemIcon>
                                        <ListItemText primary="Planificación Multidía" />
                                    </ListItem>
                                </Link>
                            )}

                            {config && config.menu && config.menu.showRepartosRealizados !== false && (
                                <Link to="/races">
                                    <ListItem button>
                                        <ListItemIcon>
                                            <AssignmentIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Repartos realizados" />
                                    </ListItem>
                                </Link>
                            )}

                        </List>
                    </Collapse>
                </>
            )}
            {config && config.menu && config.menu.showVisitas !== false && (
                <>
                    <ListItem button onClick={() => cambiar()} >
                        <ListItemIcon>
                            <TouchApp />
                        </ListItemIcon>
                        <ListItemText primary="VISITAS" />
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link to="/visits/add">
                                <ListItem button>
                                    <ListItemIcon>
                                        <LocationOn />
                                    </ListItemIcon>
                                    <ListItemText primary="Agendar Visitas" />
                                </ListItem>
                            </Link>

                            <Link to="/visits">
                                <ListItem button>
                                    <ListItemIcon>
                                        <AssignmentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Visitas realizadas" />
                                </ListItem>
                            </Link>

                        </List>
                    </Collapse>
                </>
            )}
            <Divider />
            {config && config.menu && config.menu.showSistema !== false && (
                <>
                    <ListItem button onClick={() => cambiarEnterprise()} >
                        <ListItemIcon>
                            <BusinessIcon />
                        </ListItemIcon>
                        <ListItemText primary="SISTEMA" />
                        {openEnterprise ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openEnterprise} timeout="auto" unmountOnExit>
                        <Link to="/clients">
                            <ListItem button>
                                <ListItemIcon>
                                    <PeopleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Clientes" />
                            </ListItem>
                        </Link>
                        <Link to="/driver">
                            <ListItem button>
                                <ListItemIcon>
                                    <DriveEta />
                                </ListItemIcon>
                                <ListItemText primary="Usuarios" />
                            </ListItem>
                        </Link>
                        <Link to="/admin">
                            <ListItem button>
                                <ListItemIcon>
                                    <LocalOffer />
                                </ListItemIcon>
                                <ListItemText primary="Administradores" />
                            </ListItem>
                        </Link>
                        <Link to="/message">
                            <ListItem button>
                                <ListItemIcon>
                                    <MessageIcon />
                                </ListItemIcon>
                                <ListItemText primary="Enviar mensaje" />
                            </ListItem>
                        </Link>
                        <Link to="/company">
                            <ListItem button>
                                <ListItemIcon>
                                    <BusinessIcon />
                                </ListItemIcon>
                                <ListItemText primary="Empresas" />
                            </ListItem>
                        </Link>
                        <Link to="/branch">
                            <ListItem button>
                                <ListItemIcon>
                                    <Store />
                                </ListItemIcon>
                                <ListItemText primary="Sucursales" />
                            </ListItem>
                        </Link>
                    </Collapse>
                </>
            )}
            {config && config.menu && config.menu.showReportes !== false && (
                <>
                <Divider />
                    <ListItem button onClick={() => cambiarReportes()} >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Reportes" />
                        {openReportes ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openReportes} timeout="auto" unmountOnExit>
                        <Link to="/reports">
                            <ListItem button>
                                <ListItemIcon>
                                    <AssignmentIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reporte General" />
                            </ListItem>
                        </Link>
                        {/* <Link to="/report-races">
                            <ListItem button>
                                <ListItemIcon>
                                    <AssignmentIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reporte de Repartos" />
                            </ListItem>
                        </Link> */}
                    </Collapse>
                </>
            )}
            {/* <Divider /> */}
        </List>
    </div>
};


// WEBPACK FOOTER //
// ./src/menu.tsx